import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/Button";
import Input from "components/Input";
import Link from "components/Link";
import SEO from "components/SEO";
import Text from "components/Text";
import SessionContext from "components/session/SessionContext";
import SetPassword from "components/setPassword";
import { greybackground, pagePadding } from "data/commonClasses";
import { fetchFromAPI, handleNumber } from "functions";
import { useContext, useState } from "react";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "auto",
    backgroundImage: `url(/engineerzone.png)`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    padding: "3%",
    [theme.breakpoints.down("769")]: {
      width: "100%",
    },
  },
  containerContent: {
    display: "flex",
    flexDirection: "column",
    width: "35%",
    padding: "3%",
    [theme.breakpoints.down("1100")]: {
      width: "50%",
    },
    [theme.breakpoints.down("400")]: {
      width: "95%",
    },
    margin: "0 auto",
  },
  title: {
    width: "100%",
    height: "auto",
    padding: "0 7.5%",
    margin: "1% 0",
    [theme.breakpoints.down("769")]: {
      width: "90%",
    },
  },
  subtitle: {
    borderLeftColor: "#F5B750",
    borderLeftStyle: "solid",
    borderLeftWidth: 7,
    fontSize: 26,
    color: "#344450",
    fontWeight: "bold",
    padding: "2% 3%",
    margin: "1% 0",
    [theme.breakpoints.down("1100")]: {
      borderLeftWidth: 5,
      fontSize: 22,
    },
    [theme.breakpoints.down("769")]: {
      borderLeftWidth: 3,
      fontSize: 18,
    },
  },
  inputLabel: {
    color: "#344450",
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: "3%",
    [theme.breakpoints.down("769")]: {
      fontSize: 15,
    },
  },
  root: {
    "& .MuiInputBase-input": {
      color: "#344450",
    },
    "& label.Mui-focused": {
      color: "#F5B750",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#F5B750",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#344450",
      },
      "&:hover fieldset": {
        borderColor: "#344450",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#F5B750",
      },
    },
    width: "100%",
    margin: "auto",
    marginBottom: 40,
    [theme.breakpoints.down("769")]: {
      marginBottom: 20,
    },
  },
  rootAR: {
    "& label": {
      transformOrigin: "top left",
      right: 20,
      left: "auto",
      "&.Mui-focused": {
        right: 3,
      },
    },
    "& legend": {
      textAlign: "right",
    },
    "& .MuiInputBase-input": {
      color: "#344450",
    },
    "& label.Mui-focused": {
      color: "#F5B750",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#F5B750",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#344450",
      },
      "&:hover fieldset": {
        borderColor: "#344450",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#F5B750",
      },
    },
    width: "100%",
    margin: "auto",
    marginBottom: 40,
    [theme.breakpoints.down("769")]: {
      marginBottom: 20,
    },
  },
  multilineColor: {
    padding: "0 2%",
    color: "#344450",
    fontSize: 16,
    [theme.breakpoints.down("1100")]: {
      fontSize: 14,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 12,
      // height: 25
    },
  },
  button: {
    backgroundColor: "#344450",
    color: "#FFFFFF",
    padding: "3% 6%",
    // paddingTop: '2%',
    // paddingBottom: '2%',
    margin: "3% 0",
    fontSize: 15,
    "&:hover": {
      backgroundColor: "#F5B750",
    },
    [theme.breakpoints.down("1100")]: {
      fontSize: 12,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 10,
    },
  },
  linkPage: {
    color: "#344450",
    width: "fit-content",
    fontSize: 15,
    fontWeight: "bold",
    [theme.breakpoints.down("1100")]: {
      fontSize: 12,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 10,
    },
  },
  linkPageHover: {
    cursor: "pointer",
    "&:hover": {
      color: "#F5B750",
    },
    textDecoration: "underline",
  },
  introSentence: {
    color: "#344450",
    fontSize: 24,
    fontWeight: "bold",
    textAlign: "center",
    marginTop: "2%",
    [theme.breakpoints.down("769")]: {
      fontSize: 16,
    },
  },
  errorText: {
    color: "red",
    width: "fit-content",
    fontWeight: "bold",
    margin: "0 auto",
    fontSize: 20,
    [theme.breakpoints.down("1100")]: {
      fontSize: 18,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 16,
    },
  },
  boxSendCode: {
    border: "2px solid #F5B750",
    width: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    margin: "1%",
    padding: "2%",
    [theme.breakpoints.down("769")]: {
      width: "90%",
    },
    [theme.breakpoints.down("1250")]: {
      width: "70%",
    },
  },
  sendby: {
    color: "#344450",
    fontSize: 20,
    fontWeight: "bold",
    [theme.breakpoints.down("769")]: {
      fontSize: 16,
    },
  },
  buttonsBox: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    marginTop: "3%",
    [theme.breakpoints.down("769")]: {
      flexDirection: "column",
      width: "fit-content",
    },
    gap: 5
  },
  buttonSend: {
    backgroundColor: "#344450",
    color: "#FFFFFF",
    minWidth: 100,
    fontSize: 16,
    padding: "2% 4%",
    "&:hover": {
      backgroundColor: "#F5B750",
    },
    [theme.breakpoints.down("1100")]: {
      fontSize: 14,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 14,
      margin: "2%",
      height: 50,
    },
    textTransform: "none",
  },
}));

export default function ForgotPassword() {
  const classes = useStyles();
  const { t } = useTranslation();

  let {
    session: { lang },
  } = useContext(SessionContext);
  let isAr = lang === "ar";

  const [state, updateState] = useState({
    request: "",
    sentCode: "",

    engId: "",
    code: "",

    newPass: "",
    conPass: "",
    showNewPass: false,
    showConPass: false,

    isWrongEmail: false,
  });

  function setState(nextState) {
    updateState((prevState) => ({
      ...prevState,
      ...nextState,
    }));
  }

  function handleChange(e) {
    let { name, value } = e.target;
    setState({ [name]: value });
    if (state.isWrongEmail) setState({ isWrongEmail: false });
  }

  async function handleForgot(e) {
    e.preventDefault();
    let { engId } = state;
    let reqBody = { email: engId };
    let response = await fetchFromAPI({ api: "auth/forgotpassword", reqBody });
    if (response.status == "success") {
      let request = response.response;
      setState({ request });
    } else {
      setState({ isWrongEmail: true });
    }
  }

  async function handleSendCode(method) {
    let {
      engId,
      request: { reqId },
    } = state;
    let reqBody = { method, engId, reqId };
    let response = await fetchFromAPI({
      api: "auth/sendResetPasswordCode",
      reqBody,
    });
    let sentCode = response.status;
    setState({ sentCode });
  }

  return (
    <div className={`${pagePadding} mb-5`}>
      <SEO title={t("forgotPassword")} description={t("forgotPassword")} />
      <div
        className={twMerge(greybackground,`flex items-center justify-center flex-col`)}
      >
        {state.sentCode != "success" && (
          <Text
            center
            bold
            sectionTitle
            text={state.sentCode != "success" ? t("forgotPassword") : null}
          />
        )}
        <div className=" flex items-center justify-center flex-col"> 
          {!state.request.reqId  ? (
            <form
              onSubmit={handleForgot}
              className="w-full flex flex-col items-center gap-5 mt-5"
            >
                <Input
                  required
                  name="engId"
                  value={state.engId}
                  direction={isAr ? "rtl" : "ltr"}
                  className={`input w-full`}
                  leftIconName={"ic:baseline-engineering"}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: e.target.name,
                        value: handleNumber(e.target.value),
                      },
                    })
                  }
                  placeholder={t("engineerId")}
                />

                {state.isWrongEmail && (
                  <Text
                    text={t("userDoesNotExists")}
                    className={"text-red w-fit mx-auto font-JR"}
                  />
                )}
                <div className="w-full">
                <Button className="w-full" title={t("send")} type="submit" />

                </div>

                <div className="w-full">
                  <div className="flex flex-wrap flex-row justify-start">
                    <Text
                      text={t("resetCodeReceived")}
                      className={"text-oeaMain text-input md:text-infoText"}
                    />

                    <Link href={`/confirmEnroll`} as={`/confirmEnroll`}>
                      <a>
                        <Text
                          className={
                            "text-oeaMain hover:text-orange underline text-input md:text-infoText font-bold ml-2"
                          }
                          text={t("resetPassword")}
                        />
                      </a>
                    </Link>
                  </div>
                  <div className="flex mt-2">
                    <div className="flex flex-row justify-start">
                      <Text
                        text={t("rememberedPassword")}
                        className={"text-oeaMain text-input md:text-infoText "}
                      />

                      <Link href={`/signin`} as={`/signin`}>
                        <a>
                          <Text
                            className={
                              "text-oeaMain mx-2 hover:text-orange underline text-input md:text-infoText font-bold"
                            }
                            text={t("signIn")}
                          />
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
            </form>
          ) : state.sentCode != "success" ? (
            <div className={classes.boxSendCode}>
              <div className={classes.sendby}>
                {t("pleaseChooseResetPasswordMethod")}
              </div>
              <div className={classes.buttonsBox}>
                <Button
                  type="button"
                  className={classes.buttonSend}
                  onClick={() => handleSendCode("email")}
                  title={`${t("email")} : ${state.request.email.replace(
                    /X/g,
                    "x"
                  )}`}
                ></Button>
                <Button
                  type="button"
                  className={classes.buttonSend}
                  onClick={() => handleSendCode("phoneNumber")}
                  title={`${t("sms")} : ${state.request.phoneNumber.replace(/X/g, "x")}`}
                >
                </Button>
              </div>
              
            </div>
          ) : (
            <SetPassword route="resetPassword" />
          )}
        </div>
      </div>
    </div>
  );
}

ForgotPassword.options = {
  allow: ["guest"],
  redirectTo: { href: "/", as: "/" },
};
